import React from 'react'
import OrderDetail from './OrderDetail/OrderDetailListing/OrderDetail'
import OrderInfo from './OrderDetail/OrderInfo/OrderInfo'

const OrderDetails = () => {
    return (
        <>
            <div id="main" className="order-detail-page">
                <div className="container">
                    <OrderInfo />
                    <OrderDetail />
                </div>
            </div>
        </>
    )
}

export default OrderDetails